module.exports = __webpack_public_path__ + "static/media/volun-image-desktop-1.44a74603.png";